const SITE_URL = "https://yourmomentsong.com";

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Your Moment Song",
  url: SITE_URL,
  logo: `${SITE_URL}/images/YourMomentSonglogo_transparent_BG.png`,
  description: "Custom-composed songs for life's most meaningful moments.",
  contactPoint: {
    "@type": "ContactPoint",
    email: "song@yourmomentsong.com",
    contactType: "customer service",
  },
  sameAs: [],
};

export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "Your Moment Song",
  url: SITE_URL,
};

export const productSchemas = [
  {
    "@context": "https://schema.org",
    "@type": "Product",
    name: "Essentials Custom Song",
    description: "A personalized song created from your story with custom lyrics and music. Digital MP3 delivery.",
    brand: { "@type": "Brand", name: "Your Moment Song" },
    offers: {
      "@type": "Offer",
      price: "35.00",
      priceCurrency: "USD",
      availability: "https://schema.org/InStock",
      url: `${SITE_URL}/pricing`,
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "Product",
    name: "Premium Song + Slideshow",
    description: "A personalized song with a professionally paced slideshow video featuring 15–40 of your photos. Includes MP4 video and digital lyric sheet.",
    brand: { "@type": "Brand", name: "Your Moment Song" },
    offers: {
      "@type": "Offer",
      price: "85.00",
      priceCurrency: "USD",
      availability: "https://schema.org/InStock",
      url: `${SITE_URL}/pricing`,
    },
  },
];

export const createFaqSchema = (faqs: { question: string; answer: string }[]) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((faq) => ({
    "@type": "Question",
    name: faq.question,
    acceptedAnswer: {
      "@type": "Answer",
      text: faq.answer,
    },
  })),
});

export const createBreadcrumbSchema = (items: { name: string; url: string }[]) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((item, index) => ({
    "@type": "ListItem",
    position: index + 1,
    name: item.name,
    item: item.url,
  })),
});

export const createBlogPostSchema = (post: {
  title: string;
  description: string;
  url: string;
  image?: string;
  publishedDate?: string;
  author?: string;
}) => ({
  "@context": "https://schema.org",
  "@type": "BlogPosting",
  headline: post.title,
  description: post.description,
  url: post.url,
  image: post.image,
  datePublished: post.publishedDate,
  author: {
    "@type": "Organization",
    name: post.author || "Your Moment Song",
  },
  publisher: {
    "@type": "Organization",
    name: "Your Moment Song",
    logo: {
      "@type": "ImageObject",
      url: `${SITE_URL}/images/YourMomentSonglogo_transparent_BG.png`,
    },
  },
});
